exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-box[data-v-484e12b5] .el-button{margin:2px}\n", ""]);

// exports
